import "./styles/home.scss";
// import { motion } from "framer-motion";
import Sharearea from "./components/sharearea";
import Newsarea from "./components/newsarea";
import Careerarea from "./components/careerarea";
// import ScrollEvent from "../../components/scrollevent";
import HomeCampaignPopup from "./components/HomeCampaignPopup";
import HomeBannerCarousel from "./components/HomeBannerCarousel";

function Home(props) {

    // Reels 影片資料
    const reels = [
        {
            id: "kzG1lIMK4eI",
            title: "AI 時代來臨｜會計人的未來挑戰、轉型與應變策略"
        },
        {
            id: "cjSLxcVNZmo",
            title: "美國管理會計師 CMA，大學在學生準備更快"
        },
        {
            id: "UzD-u49WihE",
            title: "就算只考一科，也能讓美國人刮目相看！"
        },
        {
            id: "pNr6T7ijlBI",
            title: "準備 CPA 讓我更清楚自己喜歡的職涯方向！"
        }
    ];

    return (
        <>
            <HomeCampaignPopup />
            {/* banner */}
            {/* <div className="banner mb-5">
                <motion.div
                    initial={{ opacity: 0, x: 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                    }}
                >
                    <img src="./homeImg/1.jpg" alt="" />
                </motion.div>

                <div className="bannerblock dis"></div>

                <div className="bannertext dis">
                    <div className="lgtext dis">
                        Becker<br />
                        <div className="lxtext">
                            CPA<br />
                        </div>
                        Exam Review<br />
                    </div>
                    全球最具權威領導品牌的<br />
                    財會培訓軟體<br />
                </div>

                <ScrollEvent />
            </div> */}

            {/* banner */}
            <div className="mb-5">
                <HomeBannerCarousel />
            </div>

            {/* news */}
            <Newsarea />

            {/* Reels 影片區塊 */}
            <section className="home-reels-section">
                <div className="container">

                    <div className="home-reels-header">
                        <h2>Becker 精彩影音</h2>
                        <p>
                            透過精彩短影音，了解更多 Becker
                        </p>
                    </div>

                    <div className="home-reels-grid">
                        {reels.map((reel, index) => (
                            <div
                                className="home-reels-item"
                                key={index}
                            >
                                <div className="home-reels-video">
                                    <iframe
                                        src={`https://www.youtube.com/embed/${reel.id}?autoplay=0&playsinline=1&rel=0`}
                                        title={reel.title}
                                        loading="lazy"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    />
                                </div>

                                <div className="home-reels-title">
                                    {reel.title}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* share */}
            <Sharearea />

            <Careerarea />
        </>
    );
}

export default Home;